var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    content: _vm.title,
    classes: 'new-tooltip',
  }),expression:"{\n    content: title,\n    classes: 'new-tooltip',\n  }"}],class:[_vm.css(), _vm.css('', _vm.type)],on:{"click":function () { return _vm.onClick(); }}},[_c('AtomIcon',{attrs:{"name":_vm.iconName,"size":20}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }